<template>
  <div>
    <div>
      <!-- <Tag
        v-for="item in count"
        :key="item"
        :name="item"
        closable
        @on-close="handleClose2"
      >标签{{ item + 1 }}</Tag>
      <Input search enter-button placeholder="Enter something..."/>
      <Button icon="ios-add" type="dashed" size="small" @click="handleAdd">添加条件</Button>-->
      <Button type="primary" icon="ios-search" @click="searchByConditionsView">按条件查询</Button>
    </div>

    <!-- 模态框 -->
    <div>
      <Modal title="Title" v-model="modal8" :mask-closable="false" width="380">
        <p slot="header" style="color:#0066FF;text-align:center">
          <Icon type="md-create" />
          <span>按条件检索</span>
        </p>
        <div style="text-align:center">
          <CheckboxGroup v-model="selectedCondition" class="check_grop">
            <div>
              <Checkbox label="saveId">
                <span>存储编号</span>
              </Checkbox>
              <Input v-model="saveIdModel" placeholder="请输入存储编号" style="width: 150px" />
            </div>
            <div>
              <Checkbox label="deviceId">
                <span>设备编号</span>
              </Checkbox>
              <Input v-model="deviceIdModel" placeholder="请输入设备编号" style="width: 150px" />
            </div>
            <div>
              <Checkbox label="commandId">
                <span>命令字&nbsp;&nbsp;&nbsp;</span>
              </Checkbox>
              <Select v-model="commandIdModel" style="width:150px" placeholder="请选择命令字">
                <Option v-for="(value, key) in commandEnum" :value="key" :key="value">{{value}}</Option>
              </Select>
            </div>
            <div>
              <Checkbox label="timeStamp">
                <span>时间区间</span>
              </Checkbox>
              <Tooltip
                transfer
                placement="top"
                :disabled="timeStampModel == undefined || timeStampModel[0] == ''"
              >
                <div slot="content">
                  <span>{{dateFtt('yyyy-MM-dd hh:mm:ss',timeStampModel[0])}}</span>
                  <br />
                  <span style="margin-left:50%">~</span>
                  <br />
                  <span>{{dateFtt('yyyy-MM-dd hh:mm:ss',timeStampModel[1])}}</span>
                </div>
                <DatePicker
                  v-model="timeStampModel"
                  type="daterange"
                  split-panels
                  placeholder="请选择时间区间"
                  style="width: 150px"
                ></DatePicker>
              </Tooltip>
            </div>
          </CheckboxGroup>
        </div>
        <div slot="footer">
          <Button icon="md-search" type="info" size="large" long @click="searchByCondition">检索</Button>
        </div>
      </Modal>
    </div>
    <br />
    <Table size="large" border stripe :loading="loading" :columns="columns1" :data="data1">
      <template slot-scope="{ row, index }" slot="action">
        <Button type="primary" shape="circle" icon="ios-apps" @click="showData(row, index)"></Button>
      </template>
    </Table>
    <br />
    <Page
      :current="pageNo"
      :total="pageTotal"
      :page-size="pageSize"
      :page-size-opts="[5, 10, 20, 30, 40]"
      show-sizer
      show-total
      @on-change="changePage"
      @on-page-size-change="changePageSize"
    />
  </div>
</template>

<script>
import { constants } from "crypto";
export default {
  name: "up_instructions_menu",
  mounted() {
    // this.tableHeight =
    //   window.innerHeight - this.$refs.table.$el.offsetTop - 160;
  },
  created() {
    this.request();
  },
  methods: {
    dateFtt(fmt, date) {
      return global.dateFtt(fmt, new Date(date));
    },
    request() {
      var that = this;
      this.pageNo = 1;
      $.ajax({
        url: "/api/selectInstructions",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          page: 1,
          amount: that.pageSize,
          direction: "up",
          conditions: that.requestBody
        }),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          that.$Notice.success({
            title: "提示",
            desc: "查询上传指令数据成功"
          });
          console.log(data);
          that.data1 = data.body.resultList;
          that.pageTotal = data.body.amount;
          that.loading = false;
        },
        error: function(textStatus) {
          that.loading = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
      // this.$axios({
      //   method: "post",
      //   url: "/api/selectInstructions",
      //   headers: { "Content-Type": "text/json" },
      //   data: JSON.stringify({ name: 1, pwd: 2 }),
      //   transformRequest: [
      //     function(data) {
      //       // console.log(JSON.stringify(data))
      //       // console.log(qs.stringify(data))
      //       // console.log(qs.stringify(JSON.stringify(data)))
      //       console.log(data);
      //       this.data1 = data;
      //     }
      //   ]
      // });
    },

    ok() {},
    cancel() {},
    del() {},
    // 修改页面容量
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.request();
    },
    // 修改
    changePage(index) {
      this.pageNo = index;
      var that = this;
      that.loading = true;
      this.pageNo = 1;
      $.ajax({
        url: "/api/selectInstructions",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          page: index,
          amount: that.pageSize,
          direction: "up",
          conditions: that.requestBody
        }),
        dataType: "json",
        success: function(data) {
          console.log(data);
          if (data.errorCode == 0) {
            that.data1 = data.body.resultList;
            that.pageTotal = data.body.amount;
            that.loading = false;
          } else {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
          }
          that.loading = false;
        },
        error: function(textStatus) {
          that.loading = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    },
    // 按条件检索点击事件
    searchByCondition() {
      this.requestBody = {};
      for (var temp in this.selectedCondition) {
        if (this.selectedCondition[temp] == "commandId") {
          if (this.commandIdModel == "") {
            continue;
          }

          this.requestBody["commandId"] = this.commandIdModel;
          // requestBody.set("commandId", this.commandIdModel);
        }
        if (this.selectedCondition[temp] == "deviceId") {
          if (this.deviceIdModel == "") {
            continue;
          }

          this.requestBody["deviceId"] = this.deviceIdModel;
          // requestBody.set("deviceId", this.deviceIdModel);
        }
        if (this.selectedCondition[temp] == "saveId") {
          if (this.saveIdModel == "") {
            continue;
          }

          this.requestBody["saveId"] = this.saveIdModel;
          // requestBody.set("saveId", this.saveIdModel);
        }
        if (this.selectedCondition[temp] == "timeStamp") {
          if (this.timeStampModel[0] == "" || this.timeStampModel[1] == "") {
            continue;
          }

          let startYear = this.timeStampModel[0].getFullYear().toString();
          let startMonth =
            this.timeStampModel[0].getMonth() >= 9
              ? (this.timeStampModel[0].getMonth() + 1).toString()
              : "0" + (this.timeStampModel[0].getMonth() + 1);
          let startDate =
            this.timeStampModel[0].getDate() >= 9
              ? this.timeStampModel[0].getDate().toString()
              : "0" + this.timeStampModel[0].getDate();

          let endYear = this.timeStampModel[1].getFullYear().toString();
          let endMonth =
            this.timeStampModel[1].getMonth() >= 9
              ? (this.timeStampModel[1].getMonth() + 1).toString()
              : "0" + (this.timeStampModel[1].getMonth() + 1);
          let endDate =
            this.timeStampModel[1].getDate() >= 9
              ? this.timeStampModel[1].getDate().toString()
              : "0" + this.timeStampModel[1].getDate();

          this.requestBody["timeStamp"] =
            startYear +
            "/" +
            startMonth +
            "/" +
            startDate +
            "-" +
            endYear +
            "/" +
            endMonth +
            "/" +
            endDate;
          // requestBody.set(
          //   "timeStamp",
          //   startYear +
          //     "/" +
          //     startMonth +
          //     "/" +
          //     startDate +
          //     "-" +
          //     endYear +
          //     "/" +
          //     endMonth +
          //     "/" +
          //     endDate
          // );
        }
      }

      // 调用接口查询
      var that = this;
      that.loading = true;
      this.modal8 = false;
      this.pageNo = 1;
      $.ajax({
        url: "/api/selectInstructions",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          page: that.pageNo,
          amount: that.pageSize,
          direction: "up",
          conditions: that.requestBody
        }),
        dataType: "json",
        success: function(data) {
          console.log(data);
          if (data.errorCode == 0) {
            that.$Notice.success({
              title: "提示",
              desc: "查询上传指令数据成功"
            });
            that.data1 = data.body.resultList;
            that.pageTotal = data.body.amount;
            that.loading = false;
          } else {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
          }
          that.loading = false;
        },
        error: function(textStatus) {
          that.loading = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    },
    // 显示条件检索页面
    searchByConditionsView() {
      this.modal8 = true;
    },
    handleClose2(event, name) {
      const index = this.count.indexOf(name);
      this.count.splice(index, 1);
    },
    // 点击事件：点击显示数据集
    showData(row, index) {
      // 遍历数据集拼接HTML
      console.log;
      var htmlStr =
        "<table style='border:1px solid #C0C0C0; text-align: center;width: 100%; '>";
      var amount = 0;
      console.log(row);
      for (let temp in row.data) {
        if (amount % 2 == 0) {
          htmlStr += "<tr >";
        }
        htmlStr +=
          "<td style='margin-top:2px; border: 1px solid #C0C0C0;'>" +
            temp +
            "</td><td style='margin-top:2px; border: 1px solid #C0C0C0;'>" +
            row.data[temp].replace("null", "") + "</td>";
        if (amount % 2 == 1) {
          htmlStr += "</tr>";
        }
        amount++;
      }
      htmlStr += "</table>";

      this.selectDataHtml = htmlStr;
      this.selectData = row.data;
      // this.showDrawer = true;

      var that = this;
      this.$Notice.open({
        title: "存储编号:" + row.saveId + "\t设备编号:" + row.deviceId,
        // desc: htmlStr,
        render: h => {
          return h("div", {
            on: {},
            style: {
              height: "100%",
              width: "100%"
            },
            domProps: {
              innerHTML: htmlStr
            }
          });
        },
        duration: 20
      });
    }
  },
  data() {
    return {
      columns1: [
        // {
        //   title: "存储编号",
        //   key: "saveId",
        //   align: "center",
        //   sortable: true,
        //   width: 120
        // },
        {
          title: "设备编号",
          key: "deviceId",
          align: "center",
          sortable: true
        },
        // {
        //   title: "设备信息",
        //   align: "center",
        //   children: [
        //     {
        //       title: "设备编号",
        //       key: "deviceId",
        //       align: "center",
        //       sortable: true
        //     },
        //     {
        //       title: "应用编号",
        //       key: "appId",
        //       align: "center"
        //     },
        //     {
        //       title: "解码配置编号",
        //       key: "profileId",
        //       align: "center"
        //     }
        //   ]
        // },
        {
          title: "命令信息",
          align: "center",
          children: [
            {
              title: "命令字",
              key: "command",
              sortable: true,
              align: "center"
              // width: 100
            },
            {
              title: "命令名称",
              key: "commandName",
              align: "center"
            }
          ]
        },
        {
          title: "日期",
          key: "time",
          sortable: true,
          align: "center"
        },
        {
          title: "接收日期",
          key: "date",
          sortable: true,
          align: "center"
        },
        {
          title: "数据集",
          slot: "action",
          align: "center",
          width: 80
        }
      ],

      data1: [],
      loading: true,
      showDrawer: false,
      selectDataHtml: "",
      selectData: {},
      modal8: false,
      pageTotal: 0,
      pageSize: 30,
      selectedCondition: [],
      commandEnum: global.upcommand,
      saveIdModel: "",
      deviceIdModel: "",
      commandIdModel: "",
      timeStampModel: "",
      pageNo: 1,
      requestBody: {}
    };
  }
};
</script>

<style>
.ivu-notice-notice {
  width: 500px;
  right: 160px;
}
.query_condition {
  border: 1px solid #c0c0c0;
  padding: 2px;
  margin: 2px;
  border-radius: 5%;
}
.check_grop div {
  margin-bottom: 1px;
}
</style>